import React from "react";
import styled from "styled-components";
// Components
import FullButton from "../Buttons/FullButton";
// Assets
import HeaderImage from "../../assets/img/header-img.png";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";
import { motion } from "framer-motion";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function Header() {
  // WhatsApp handler for "Get Started"
  const handleGetStarted = () => {
    const url = `https://wa.me/+923350006269?text=${encodeURIComponent(
      "Hi! I need a maid service in Pakistan. Please share details."
    )}`;
    window.open(url, "_blank");
  };

  const handleFindStaff = () => {
    const url = `https://wa.me/+923350006269?text=${encodeURIComponent(
      "Hi! I'm looking to find staff (maid, driver, cook, etc.) in Pakistan."
    )}`;
    window.open(url, "_blank");
  };

  const handleRegisterWorker = () => {
    const url = `https://wa.me/+923350006269?text=${encodeURIComponent(
      "Hello! I want to register as a worker (maid/driver/cook/babysitter)."
    )}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Wrapper id="home" className="container flexSpaceCenter">
        <LeftSide className="flexCenter">
          <div>
            <h1 className="extraBold font60">
              Trusted Maids Across Pakistan
            </h1>
            <HeaderP className="font22 semiBold">
              Maids Service Pakistan provides professional maid service, domestic staff,
              drivers, helpers, babysitters, cooks, foreign staff (Filipino, Sri Lankan, Nigerian),
              and medical staff. Finding the right staff to meet your needs — in Karachi,
              Islamabad, Lahore, and all major cities.
            </HeaderP>
            <BtnWrapper>
              <FullButton title="Get a Maid Now" onClick={handleGetStarted} />
            </BtnWrapper>
          </div>
        </LeftSide>
        <RightSide>
          <ImageWrapper>
            <motion.div
              initial={{ opacity: 0, x: 100 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <LazyLoadImage
                alt="Professional maid service in Pakistan"
                src={HeaderImage}
                width="100%"
                effect="blur"
                style={{ borderRadius: "8px", display: "block" }}
              />
            </motion.div>

            <QuoteWrapper className="flexCenter darkBg radius8">
              <QuotesWrapper>
                <QuotesIcon />
              </QuotesWrapper>
              <MesgBox>
                <p className="font15 whiteColor boxPadding">
                  <em>
                    "Maids Service Pakistan gave us the most reliable, caring housemaid.
                    Our home has never been cleaner, and their support team is always
                    available. Highly recommended across Lahore and Karachi!"
                  </em>
                </p>
              </MesgBox>
            </QuoteWrapper>
            <DotsWrapper>
              <Dots />
            </DotsWrapper>
          </ImageWrapper>
          <GreyDiv></GreyDiv>
        </RightSide>
      </Wrapper>
      <div
        style={{
          padding: "50px 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#e2fef5",
        }}
      >
        <div className="container">
          <p
            className="font20"
            style={{ justifyContent: "center", textAlign: "center" }}
          >
            Looking for a maid service in Karachi, Lahore, or Islamabad?{" "}
            <strong>Maids Service Pakistan</strong> connects you with reliable,
            background-verified domestic staff. We carefully screen and select
            experienced, professional, and efficient maids. We understand the
            importance of finding the right fit for your home and needs, so we
            take time to match you perfectly. With our service, your home is in
            safe, caring hands — anywhere in Pakistan.
          </p>
          <InfoButton>
            <InfoBtnWrapper>
              <FullButton title="Find Staff for Me" onClick={handleFindStaff} />
            </InfoBtnWrapper>
            <InfoBtnWrapper>
              <FullButton
                title="Register as Worker"
                onClick={handleRegisterWorker}
              />
            </InfoBtnWrapper>
          </InfoButton>
        </div>
      </div>
    </>
  );
}

const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;
const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin-top: 30px;
  }
`;

const InfoButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3%;
  flex-direction: row;
  gap: 10px;

  @media (max-width: 960px) {
    margin-top: 2%;
  }
`;
const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 50px 0;
  line-height: 1.5rem;
  @media (max-width: 960px) {
    padding: 15px 0 50px 0;
    text-align: center;
    max-width: 100%;
  }
`;
const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;

const InfoBtnWrapper = styled.div`
  max-width: 190px;
  width: 100%;
  @media (max-width: 960px) {
    margin: 0 auto;
    width: 100%;
  }
`;
const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  background-color: #e2fef5;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  margin-bottom: 20%;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
const MesgBox = styled.div`
  padding-left: 5px;
  padding-right: 5px;
  color: black;
`;
const QuoteWrapper = styled.div`
  position: absolute;
  left: -50px;
  bottom: -100px;
  max-width: 330px;
  padding: 30px !important;
  z-index: 99;
  @media (max-width: 960px) {
    left: 25px;
  }
  @media (max-width: 560px) {
    bottom: -130px;
  }
`;
const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;